import store from "../../../store/store";
import constants from "../../../utils/constants";
import axios from "../../axios";
// Token Refresh
let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function onAccessTokenFetched(access_token) {
	subscribers = subscribers.filter(callback => callback(access_token));
}

function addSubscriber(callback) {
	subscribers.push(callback);
}

export default {
	getListUsers(payload) {
		return axios.post(constants.API.USERS.LIST, payload);
	},
	getListUsers2(payload) {
		return axios.post(constants.API.USERS.LIST2, payload);
	},
	getListUsers3(payload) {
		return axios.post(constants.API.USERS.LIST3, payload);
	},
	createUser(payload) {
		return axios.post(`${constants.API.USERS.CREATE}`, payload);
	},
	updateUser(id, payload) {
		return axios.put(`${constants.API.USERS.UPDATE_USER}${id}`, payload);
	},
	deleteUser(id) {
		return axios.delete(`${constants.API.USERS.DELETE_USER}${id}`);
	},
	exportData(payload) {
		return axios.post(`${constants.API.USERS.EXPORT}${payload}`, payload);
	}
};
